import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ServiceMenu from "../../components/services/ServiceMenu";
import { CategoryAPI } from "../../api";
import { Helmet } from "react-helmet-async";

const Service = () => {
	const { category, item } = useParams();
	const [ServiceItem, setServiceItem] = useState([]);
	const [meta, setMeta] = useState({
		title: "",
		description: "",
		keywords: "",
	});
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setIsLoading(true);
		CategoryAPI.getServiceItem(item)
			.then((res) => {
				setServiceItem(res.data);
				setMeta({
					title: res.data.meta_title || res.data.title,
					description: res.data.meta_description || res.data.short_description,
					keywords: res.data.meta_keywords || res.data.title,
				});
				setIsLoading(false);
			})
			.catch((err) => console.error(err));
	}, [category, item]);

	return (
		<>
			<Helmet>
				<title>{meta.title}</title>
				<meta name="description" content={meta.description} />
				<meta name="keywords" content={meta.keywords} />
			</Helmet>
			<section className="container service-item-page my-5">
				{/* left side */}
				<div className="service-item-banner">
					{isLoading && <div>Loading...</div>}
					{!isLoading && (
						<>
							<span className="breadcrumb">
								{ServiceItem?.category?.title} &gt; {ServiceItem?.title}
							</span>
							<img
								src={ServiceItem?.image}
								alt={ServiceItem?.title}
								loading="lazy"
							/>
							<div>
								<h2 className="text-uppercase">{ServiceItem?.title}</h2>
								<p>{ServiceItem?.description}</p>
							</div>
						</>
					)}
				</div>
				{/* right side */}
				<div className="service-item-right">
					<ServiceMenu />
				</div>
			</section>
		</>
	);
};

export default Service;
